import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'

// Панель детали грузится на переходе — не тянем её в стартовый бандл.
const UnitDetail = lazyRouteComponent(() => import('@/widgets/unit-detail'), 'UnitDetail')

export const Route = createFileRoute('/units/$unitId')({
  component: UnitPage,
})

function UnitPage() {
  const { unitId } = Route.useParams()
  return (
    <>
      <Breadcrumbs current={unitId} />
      <UnitDetail unitId={unitId} />
    </>
  )
}
